"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var yellow = {
  1: '',
  2: '#FFF277',
  3: '#FFC300',
  4: '#FFB020',
  5: ''
};
var _default = yellow;
exports.default = _default;